<template>
  <div class="w-full px-3 py-2 flex" :class="classes">
    <div
      class="min-w-[40px] max-w-[40px] min-h-[40px] max-h-[40px] mr-3 p-0.5 rounded-sm bg-gray-200/20 relative"
    >
      <ThumbnailIcon
        class="w-9 h-9"
        :image-url="notification.primaryIcon.imageUrl"
        :type="file.type"
        :icon-size="36"
      />
    </div>
    <div
      class="font-secondary text-[14px] leading-5 tablet-h:leading-[19px] tablet-h:text-[13px] text-gray-800 -mt-1 flex flex-col justify-between"
    >
      <component :is="copy" class="mb-1 tablet-h:mb-0.5" />
      <div class="text-[13px] tablet-h:text-[12px] opacity-50">
        {{ formatDistanceToNowStrict(props.notification.timestamp) }} ago
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  NotificationType,
  type FileMetadata,
  type Notification,
} from '@/shared/graphql/legacy/generated'
import { formatDistanceToNowStrict } from 'date-fns'
import { computed, h } from 'vue'
import { ThumbnailIcon } from '@dacr/ui'
import { RouterLink } from 'vue-router'

const props = defineProps<{
  notification: Notification
}>()

const classes = computed(() => ({
  'tablet-h:hover:bg-[#FAFAFA]': props.notification.read,
  'bg-green-900/10': !props.notification.read,
}))

const file = computed(() => (props.notification.metadata as FileMetadata).file)

const copy = computed(() => {
  if (props.notification.type === NotificationType.ReceivedFile) {
    return h('div', [
      'You are the new owner of the copyright for ',
      h(
        RouterLink,
        {
          to: `/file/${file.value?.copyrightId}`,
          class: 'font-medium text-green-900 break-all',
        },
        () => file.value?.fileName
      ),
      `. The file and Dacr token for this copyright have been moved into your account`,
    ])
  }

  if (props.notification.type === NotificationType.ReceivedLicense) {
    return h('div', [
      'You are now a licensee for the copyright of ',
      h(
        RouterLink,
        {
          to: `/file/${file.value?.copyrightId}`,
          class: 'font-medium text-green-900 break-all',
        },
        () => file.value?.fileName
      ),
      `. The file and Dacr license token for this copyright have been moved into your account`,
    ])
  }

  return null
})
</script>
